import React from 'react';
import { motion } from 'framer-motion';

const portals = [
  {
    id: 'vesta-plans',
    title: 'Vesta Plans',
    suffix: 'Plan',
    description: 'Access your architectural plans and project documents',
    image: '/portal-plans.png',
    roundImg: true,
    url: 'https://plans.vestadesigns.com.au'
  },
  {
    id: 'vesta-view',
    title: 'Vesta View',
    suffix: 'View',
    description: 'Planning permits map & document viewer',
    image: '/portal-view.png',
    roundImg: true,
    url: 'https://maps.vestadesigns.com.au'
  },
  {
    id: 'client-portal',
    title: 'Vesta Projects',
    suffix: 'Projects',
    description: 'Manage your projects, invoices and communications',
    image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80',
    roundImg: true,
    url: '#'
  }
];

const Login = () => {
  return (
    <div className="portal-page">
      {/* Hero Section */}
      <section className="portfolio-hero">
        <div 
          className="portfolio-hero-bg"
          style={{ 
            backgroundImage: 'url(https://images.unsplash.com/photo-1600607687644-aac4c3eac7f4?w=1920&q=80)' 
          }}
        />
        <div className="portfolio-hero-overlay" />
        <div className="container">
          <motion.div 
            className="portfolio-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="portfolio-hero-title">Portals</h1>
          </motion.div>
        </div>
      </section>

      {/* Portal Cards Grid */}
      <section className="portal-grid-section">
        <div className="container">
          <motion.div 
            className="portal-grid"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            {portals.map((portal, index) => (
              <motion.a 
                key={portal.id}
                className={`portal-card${portal.roundImg ? ' portal-card--round-img' : ''}`}
                href={portal.url}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
              >
                <div className="portal-card-image">
                  <img src={portal.image} alt={portal.title} />
                </div>
                <div className="portal-card-brand">
                  <span className="portal-brand-name">VESTA</span>
                  <span className="portal-brand-sep">|</span>
                  <span className="portal-brand-suffix">{portal.suffix}</span>
                </div>
              </motion.a>
            ))}
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Login;
